var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3753 39.3748L31.2378 31.2373",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2316 10.0184C37.0895 15.8762 37.0895 25.3738 31.2316 31.2315C25.3737 37.0894 15.8762 37.0894 10.0184 31.2315C4.16054 25.3738 4.16054 15.8762 10.0184 10.0184C15.8762 4.16054 25.3737 4.16054 31.2316 10.0184Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5353 15.2083C26.0328 15.2083 27.709 17.5351 27.709 19.7045C27.709 24.1051 20.7528 27.7089 20.6253 27.7089C20.4978 27.7089 13.5415 24.1051 13.5415 19.7045C13.5415 17.537 15.2178 15.2083 17.7153 15.2083C19.144 15.2083 20.0815 15.9151 20.6253 16.5451C21.1671 15.9151 22.1065 15.2083 23.5353 15.2083Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationSearch);
export default __webpack_public_path__ + "static/media/navigation-search.e3be7416.svg";
export { ForwardRef as ReactComponent };